// COPIED FROM @wix/ambassador-devcenter-v1-component-type-data/types to decrease pakcage bundle size

export interface DataAction {
  /**
   * Points to the data item within the component’s data structure
   * @minLength 1
   * @maxLength 50
   */
  dataItemKey?: string;
}

export interface StyleAction {
  /**
   * Points to the style item within the component’s style structure
   * @minLength 1
   * @maxLength 50
   */
  styleItemKey?: string;
}

export interface EventAction {
  /**
   * Name of the event to be handled by the editor script
   * @minLength 1
   * @maxLength 50
   */
  event?: string;
}

/** Represents the information needed for code panels */
export interface CodePanel {
  /**
   * The url for the panel code
   * @format WEB_URL
   */
  bundleUrl?: string;
  /**
   * The url for the panel css
   * @format WEB_URL
   */
  cssUrl?: string;
}

export interface PanelSelectedContentTypeOneOf {
  /**
   * The URL to the html page of the panel in case of iFrame
   * @format WEB_URL
   */
  url?: string;
  /**
   * The configuration for rendering the panel directly in the host
   * @internal
   */
  code?: CodePanel;
}

export interface PanelSize {
  /**
   * height of the panel in px
   * @min 150
   */
  height?: number | null;
  /** width of the panel */
  width?: PanelSizeWidth;
}
export enum PanelSizeWidth {
  UNKNOWN_WIDTH = 'UNKNOWN_WIDTH',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum PanelContentType {
  UNKNOWN_PanelContentType = 'UNKNOWN_PanelContentType',
  url = 'url',
  code = 'code',
}

export interface Panel extends PanelSelectedContentTypeOneOf {
  /**
   * The URL to the html page of the panel in case of iFrame
   * @format WEB_URL
   */
  url?: string;
  /**
   * The configuration for rendering the panel directly in the host
   * @internal
   */
  code?: CodePanel;
  /**
   * external reference to the panel
   * @internal
   * @maxLength 20
   */
  referenceId?: string | null;
  /**
   * The title of the panel
   * @minLength 1
   * @maxLength 200
   */
  displayName?: string;
  /** Optional: The size of the panel */
  size?: PanelSize;
  /** The selected panel content type */
  contentType?: PanelContentType;
}

export interface PanelActionSelectedPanelTypeOneOf {
  /**
   * For using a panel defined in dev-center
   * @maxLength 20
   */
  panelId?: string;
  /**
   * Internal implementation as an interim step, a defined inline panel
   * @internal
   */
  inline?: Panel;
}

export enum PanelType {
  UNKNOWN_PanelType = 'UNKNOWN_PanelType',
  panelId = 'panelId',
  inline = 'inline',
}

export interface PanelAction extends PanelActionSelectedPanelTypeOneOf {
  /**
   * For using a panel defined in dev-center
   * @maxLength 20
   */
  panelId?: string;
  /**
   * Internal implementation as an interim step, a defined inline panel
   * @internal
   */
  inline?: Panel;
  /** The selected panel reference type */
  panelType?: PanelType;
}

export enum ActionName {
  UNKNOWN_ActionName = 'UNKNOWN_ActionName',
  /** Manage the component settings, this usually aligns with component data */
  settings = 'settings',
  /** Manage the `style` information */
  design = 'design',
  /** Manage any media type `data` defined in the component */
  media = 'media',
  /** Manage items in the component data */
  manageItems = 'manageItems',
  /** Open the apps default dashboard page, or select one if there is more than one */
  dashboard = 'dashboard',
  /** actionName to be triggered from the defined custom actions */
  custom = 'custom',
}

export interface ForwardActionActionOneOf {
  /**
   * Used when actionType is custom
   * @minLength 1
   * @maxLength 50
   */
  custom?: string;
}

/** Represents an action that targets another element within the component */
export interface ForwardAction extends ForwardActionActionOneOf {
  /**
   * Used when actionType is custom
   * @minLength 1
   * @maxLength 50
   */
  custom?: string;
  /** Specifies the action names (one of the natives or custom) */
  actionName?: ActionName;
  /**
   * Path to the target element
   * @minLength 1
   * @maxLength 500
   */
  elementPath?: string;
}

export interface ExecutionActionExecuteOneOf {
  /** Executes an action that manipulates component's data */
  data?: DataAction;
  /** Executes an action that manipulates component's style */
  style?: StyleAction;
  /** Executes an event-based action. Triggered event should be intercepted in the editor script */
  event?: EventAction;
  /** Opens a URL inside an iframe panel */
  panel?: PanelAction;
  /** Executes an action on a target element (based on path) */
  forward?: ForwardAction;
}

export enum ActionType {
  UNKNOWN_ActionType = 'UNKNOWN_ActionType',
  data = 'data',
  event = 'event',
  panel = 'panel',
  forward = 'forward',
  style = 'style',
}

export interface Execution extends ExecutionActionExecuteOneOf {
  /** Executes an action that manipulates component's data */
  data?: DataAction;
  /** Executes an action that manipulates component's style */
  style?: StyleAction;
  /** Executes an event-based action. Triggered event should be intercepted in the editor script */
  event?: EventAction;
  /** Opens a URL inside an iframe panel */
  panel?: PanelAction;
  /** Executes an action on a target element (based on path) */
  forward?: ForwardAction;
  /** The action type allows to determine the return type of the execution function */
  actionType?: ActionType;
}

export interface ApiAction {
  /** Defines whether the action is being displayed */
  hidden?: boolean | null;
  /**
   * The public human-readable name given to the  action by the developer.
   * @minLength 4
   * @maxLength 20
   */
  displayName?: string;
  /** A model definition for declaring a concrete instructions action will perform */
  execution?: Execution;
}

export interface DashboardAction {
  /** Defines whether the action is being displayed */
  hidden?: boolean | null;
  /**
   * The public human-readable name given to the  action by the developer.
   * @minLength 4
   * @maxLength 20
   */
  displayName?: string;
  /**
   * Optional pageId of the dashboard in case there is more than one
   * @minLength 4
   * @maxLength 50
   */
  dashboardPageId?: string;
  /** A model definition for declaring a concrete instructions action will perform */
  execution?: Execution;
}
